<app-common-loader *ngIf="carregando"></app-common-loader>
<app-modal-mensagem
  *ngIf="sucesso"
  tipo="sucesso"
  titulo="Sucesso!"
  mensagem="Tarefa atualizada com sucesso!"
  (confirmar)="fecharSucesso()"
></app-modal-mensagem>

<div class="modal-backdrop" (click)="fecharModal()"></div>

<div class="modal-panel-tarefa">
  <div class="modal-header">
    <div class="modal-header-left">
      <div class="modal-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M9 11l3 3L22 4" />
          <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" />
        </svg>
      </div>
      <div>
        <h2 class="modal-title">Editar tarefa</h2>
        <p class="modal-subtitle">Modifique os detalhes da tarefa conforme necessário</p>
      </div>
    </div>
    <button class="btn-close" type="button" (click)="fecharModal()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <label class="form-label" for="obra">
        Obra
        <span class="required">*</span>
      </label>
      <app-filtro-select-busca
        [value]="workID"
        [options]="opcoesObras"
        placeholder="Selecione uma obra"
        placeholderBusca="Buscar obra"
        [class.form-input--error]="campoObrigatorioErro && !workID"
        (valueChange)="workID = $event"
      ></app-filtro-select-busca>
      <span class="error-msg" *ngIf="campoObrigatorioErro && !workID">Selecione uma obra</span>
    </div>

    <div class="form-row">
      <div class="form-group">
        <label class="form-label" for="responsavel">
          Responsável
          <span class="required">*</span>
        </label>
        <app-filtro-select-busca
          [value]="responsibleID"
          [options]="opcoesResponsaveis"
          placeholder="Selecione"
          placeholderBusca="Buscar responsável"
          [class.form-input--error]="campoObrigatorioErro && !responsibleID"
          (valueChange)="responsibleID = $event"
        ></app-filtro-select-busca>
        <span class="error-msg" *ngIf="campoObrigatorioErro && !responsibleID">Selecione</span>
      </div>

      <div class="form-group">
        <label class="form-label" for="tarefa">
          Tipo de tarefa
          <span class="required">*</span>
        </label>
        <select
          id="tarefa"
          class="form-select"
          [(ngModel)]="actionID"
          [class.form-input--error]="campoObrigatorioErro && !actionID"
        >
          <option value="" disabled>Selecione a ação</option>
          <option *ngFor="let t of tarefas" [value]="t.id.toString()">{{ t.description }}</option>
        </select>
        <span class="error-msg" *ngIf="campoObrigatorioErro && !actionID">Selecione</span>
      </div>
    </div>

    <div class="form-row form-row--data">
      <div class="form-group">
        <label class="form-label" for="data">Data</label>
        <input
          id="data"
          type="date"
          class="form-input"
          [min]="today"
          [(ngModel)]="data"
        />
      </div>

      <div class="form-group">
        <label class="form-label" for="hora">Hora</label>
        <input id="hora" type="time" class="form-input" [(ngModel)]="hora" />
      </div>
    </div>

    <div class="form-group">
      <label class="form-label" for="anotacao">Anotação (opcional)</label>
      <textarea
        id="anotacao"
        class="form-textarea"
        rows="4"
        [(ngModel)]="description"
        placeholder="Anotação de exemplo para esta tarefa"
      ></textarea>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn-secondary" type="button" (click)="fecharModal()">Cancelar</button>
    <button class="btn-primary" type="button" (click)="editarTarefa()" [disabled]="carregando">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <polyline points="20 6 9 17 4 12" />
      </svg>
      Salvar alterações
    </button>
  </div>
</div>
